<template>
  <v-app>
    <login
      v-if="!isAuthenticated() && !showDeferidos"
      @show-vaga-integral="
        tipoConsulta = 'vagaIntegral';
        showDeferidos = true;
      "
      @show-plantao-ferias="
        tipoConsulta = 'plantaoFerias';
        showDeferidos = true;
      "
    >
    </login>
    <cadastros-deferidos
      v-else-if="!isAuthenticated() && showDeferidos"
      :tipo-consulta="tipoConsulta"
      @show-login="showDeferidos = false"
    />
    <v-row v-else>
      <v-col cols="12">
        <template>
          <div class="menu" id="app-bar">
            <div class="nav-menu" :class="{ red: devBarColor }">
              <v-icon class="ml-5 d-sm-none" @click="showMenu()" color="white"
                >mdi-menu</v-icon
              >

              <div class="nav-content ">
                <v-col
                  cols="auto"
                  class="font-weight-medium text-body-1 d-flex align-center text-uppercase"
                >
                  <span>{{ user.nome }}</span>
                </v-col>

                <!-- MENU - VAGA INTEGRAL -->
                <v-col cols="auto">
                  <v-menu transition="slide-y-transition" offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        class="white--text"
                        large
                        outlined
                        rounded
                        v-on="on"
                      >
                        <v-icon left>
                          mdi-clipboard-text-multiple
                        </v-icon>
                        VAGA INTEGRAL
                      </v-btn>
                    </template>
                    <v-list dense class="text-center">
                      <v-list-item>
                        <v-btn
                          block
                          class="primary--text"
                          text
                          to="/novo-cadastro"
                        >
                          NOVO CADASTRO
                        </v-btn>
                      </v-list-item>
                      <v-list-item v-if="isAllowMenu">
                        <v-btn block class="primary--text" text to="/cadastros">
                          CONSULTA DE CADASTROS
                        </v-btn>
                      </v-list-item>
                      <v-list-item>
                        <v-btn block class="primary--text" text to="/protocolo">
                          IMPRIMIR PROTOCOLO
                        </v-btn>
                      </v-list-item>
                      <v-list-item v-if="isAllowMenu">
                        <v-btn block class="primary--text" text to="/processos">
                          PROCESSO DE INSCRIÇÃO
                        </v-btn>
                      </v-list-item>
                      <v-list-item v-if="isAllowMenu">
                        <v-btn
                          block
                          class="primary--text"
                          text
                          to="/relatorio-vagas"
                        >
                          Relatório de Vagas
                        </v-btn>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-col>

                <!-- MENU - PLANTÃO DE FÉRIAS -->
                <template>
                  <v-col cols="auto">
                    <v-menu transition="slide-y-transition" offset-y>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          class="white--text"
                          large
                          outlined
                          rounded
                          v-on="on"
                        >
                          <v-icon left>
                            mdi-book-plus
                          </v-icon>
                          PLANTÃO DE FÉRIAS
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-item>
                          <v-btn block class="primary--text" text to="/plantao">
                            NOVO CADASTRO
                          </v-btn>
                        </v-list-item>

                        <v-list-item>
                          <v-btn
                            block
                            class="primary--text"
                            text
                            to="/consulta-plantao-unidades"
                          >
                            CONSULTA POR UNIDADE
                          </v-btn>
                        </v-list-item>

                        <v-list-item v-if="isAllowMenu">
                          <v-btn
                            block
                            class="primary--text"
                            text
                            to="/consulta-plantao"
                          >
                            LISTAR CADASTROS
                          </v-btn>
                        </v-list-item>

                        <v-list-item>
                          <v-btn
                            block
                            class="primary--text"
                            text
                            to="/protocolo-plantao"
                          >
                            TERMO DE COMPROMISSO
                          </v-btn>
                        </v-list-item>

                        <v-list-item>
                          <v-btn
                            block
                            class="primary--text"
                            text
                            to="/encaminhamento-plantao"
                          >
                            PROTOCOLO DE ENCAMINHAMENTO
                          </v-btn>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </v-col>
                </template>
                <v-expand-transition>
                  <ul class="nav-items" v-if="showMobileMenu"></ul>
                </v-expand-transition>
                <Profile />
              </div>
            </div>
          </div>
        </template>

        <v-main class="main">
          <v-container class="mt-10 ">
            <router-view />
          </v-container>
        </v-main>
      </v-col>
    </v-row>
    <CPTSnackbar />
  </v-app>
</template>

<script>
import CadastrosDeferidos from "@/pages/Login/CadastrosDeferidos";
import CPTSnackbar from "@/components/Snackbar";
import Profile from "@/pages/Profile/VagaProfile.vue";
import Login from "@/pages/Login";
import {
  isAdmin,
  isGestor,
  isAuthenticated,
  logout,
  getUser,
} from "@/plugins/security";

export default {
  name: "App",

  components: {
    CadastrosDeferidos,
    CPTSnackbar,
    Login,
    Profile,
  },

  data: () => ({
    user: getUser(),
    showMobileMenu: true,
    showDeferidos: false,
    expand: true,
    tipoConsulta: "vagaIntegral",
    items: [
      { title: "NOVO CADASTRO" },
      { title: "CONSULTA DE CADASTROS" },
      { title: "IMPRIMIR PROTOCOLO" },
      { title: " PROCESSO-INSCRIÇÃO" },
    ],
  }),

  computed: {
    devBarColor() {
      return process.env.NODE_ENV === "development";
    },
    isAllowMenu() {
      return isAdmin() || isGestor();
    },
  },

  methods: {
    isAdmin,
    isAuthenticated,
    isGestor,
    logout,

    showMenu() {
      this.showMobileMenu = !this.showMobileMenu;
      this.expand = !this.expand;
    },
  },
};
</script>

<style lang="scss" scoped>
.Menu {
  margin-right: 10px;
  list-style-type: none;
}
.nav-menu {
  color: white;
  background-color: #1976d2;
  box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.329);
}
.nav-content {
  display: flex;
  justify-content: space-between;
  padding: 2px 15px;
  align-items: center;
}
.nav-items {
  display: flex;
  justify-content: center;
  align-items: center;
  list-style: none;
  margin: 0;
  padding: 0;
  li {
    padding: 0 10px;
  }
}
i {
  display: none;
}
// Mobile version - hidden hamburger menu
@media screen and (max-width: 768px) {
  .main {
    margin-top: 250px;
  }
  .nav-menu {
    padding-top: 10px;
    position: absolute;
    width: 100%;
  }
  .open-menu {
    opacity: 1;
    height: 150px;
  }
  .closed-menu {
    opacity: 0;
    height: 0;
    padding: 15;
  }
  .nav-content {
    flex-direction: column;
    z-index: 100;
    position: relative;
    transition: all 0.2s ease-out;
  }
  .nav-items {
    flex-direction: column;
  }
  i {
    display: block;
    text-align: right;
    padding: 0 10px 10px 0;
  }
}
</style>
